export interface JwtPayload {
  sub: string;
  email: string;
  role: string;
  tokenType: string;
  exp: number;
  iat: number;
  jti?: string;
}

/**
 * JWT payload를 파싱하여 반환
 * base64url → base64 변환 + 패딩 처리 포함
 */
export function parseJwtPayload(token: string): JwtPayload | null {
  if (!token) return null;

  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;

    // base64url → base64 변환
    let base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    // 패딩 보정
    const pad = base64.length % 4;
    if (pad) base64 += "=".repeat(4 - pad);

    const payload = JSON.parse(atob(base64));
    return payload as JwtPayload;
  } catch {
    return null;
  }
}

/**
 * JWT 토큰 만료 여부 확인
 * @param token JWT 문자열
 * @param bufferSeconds 만료 전 여유 시간 (기본 30초)
 */
export function isTokenValid(token: string, bufferSeconds = 60): boolean {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) return false;

  const now = Date.now() / 1000;
  return payload.exp - bufferSeconds > now;
}

/**
 * 토큰 잔여 시간(ms) 반환. 만료 시 0 반환.
 */
export function getTokenRemainingMs(token: string): number {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) return 0;

  const remaining = payload.exp * 1000 - Date.now();
  return Math.max(0, remaining);
}
